import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { useAppSelector } from "../../../lib/redux/hooks";
import { formatDelay } from "../../../lib/types";
import { colors } from "../../../ui/color";
import { ClockIcon } from "../../../ui/icons/clockIcon";
import { InfoIcon } from "../../../ui/icons/infoIcon";
import { Spinner } from "../../../ui/molecoles/spinner";

export function DepartureHistory() {
    const reportState = useAppSelector(state => state.report)

    if (reportState.findByIdStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <Spinner />
            </div>
        )
    }

    return (
        <div className="w-full flex justify-between items-center gap-8">
            <div className="w-full bg-pas-200 rounded-[20px] flex flex-col gap-8 justify-start p-5 h-[400px]">
                <div className="flex flex-row items-center gap-3">
                    <InfoIcon size={24} color={colors.pas[800]} />
                    <span className="text-[16px] font-bold text-pas-800 leading-6">
                        Departure flight information
                    </span>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-sm font-semibold text-pas-800">
                        Departure airport
                    </span>
                    <span className="text-text-lg ">
                        {reportState.findByIdResponse?.flight_info.flight.departure.airport.name + " (" + reportState.findByIdResponse?.flight_info.flight.departure.airport.code_iata + ")"}
                    </span>
                </div>
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Date
                        </span>
                        <span className="text-text-lg">
                            {
                                reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                    formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "dd/MM/yyyy") :
                                    "-"
                            }
                        </span>
                    </div>
                    {/* <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-bold text-pas-800">
                            Aircraft
                        </span>
                        <span className="text-text-lg">
                            {reportState.findByIdResponse?.flight_info.flight.aircraft_name}
                        </span>
                    </div> */}
                </div>
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Terminal
                        </span>
                        <span className="text-text-lg">
                            {reportState.findByIdResponse?.flight_info.flight.departure.terminal_and_gate.terminal_origin === "" ? "-" : reportState.findByIdResponse?.flight_info.flight.departure.terminal_and_gate.terminal_origin}
                        </span>
                    </div>
                    <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Gate
                        </span>
                        <span className="text-text-lg">
                            {reportState.findByIdResponse?.flight_info.flight.departure.terminal_and_gate.gate_origin !== "" ? reportState.findByIdResponse?.flight_info.flight.departure.terminal_and_gate.gate_origin : "-"}
                        </span>
                    </div>
                </div>
            </div>
            <div className="w-full bg-pas-200 rounded-[20px] flex flex-col gap-8 justify-start p-5 h-[400px]">
                <div className="flex flex-row items-center gap-3">
                    <ClockIcon size={24} color={colors.pas[800]} />
                    <span className="text-[16px] font-bold text-pas-800 leading-6">
                        Departure times
                    </span>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-lg font-bold text-pas-800">
                        Flight gate times
                    </span>
                    <div className="flex flex-row justify-start">
                        <div className="flex flex-col gap-2 w-full">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Scheduled out
                            </span>
                            <span className="text-text-lg">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.departure.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                        <div className="flex flex-col gap-2 w-full items-start">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Actual out
                            </span>
                            <span className="text-text-lg">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.actual_out_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.actual_out_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.departure.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2 w-[100%]">
                    <span className="text-text-lg font-bold text-pas-800">
                        Flight runway times
                    </span>
                    <div className="flex flex-row justify-start">
                        <div className="flex flex-col gap-2 w-full">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Scheduled off
                            </span>
                            <span className="text-text-lg">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.scheduled_off_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.scheduled_off_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.departure.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                        <div className="flex flex-col gap-2 w-full items-start">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Actual off
                            </span>
                            <span className="text-text-lg">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.actual_off_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.actual_off_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.departure.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Departure delay
                        </span>
                        <span className="text-text-lg">
                            {
                                (reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.departure_delay === "" || reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.departure_delay === "0s") ?
                                    "-" :
                                    formatDelay(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.departure_delay!)
                            }
                        </span>
                    </div>
                    <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Runway delay
                        </span>
                        <span className="text-text-lg">
                            {
                                (reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.runway_delay === "" || reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.runway_delay === "0s") ?
                                    "-" :
                                    formatDelay(reportState.findByIdResponse?.flight_info.flight.departure.flight_runway_times.runway_delay!)
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}